// ==============================================================================================
//  APPLICATION AUTHORSHIP & RIGHTS NOTICE
//
//  Developed by: Gareth Morgan
//  Brand & Product: BuildMyChecks.co.uk
//  Ownership: Sole author and rights holder
//
//  ----------------------------------------------------------------------------------------------
//  NOTICE:
//  - This application and its related systems were designed, developed, and built solely
//    by Gareth Morgan.
//  - Gareth Morgan retains full authorship, intellectual property, and creative rights to
//    all Build My Checks branding, technology, source code, architecture, and design.
//  - No ownership, license, or implied rights are granted to any third party unless
//    explicitly agreed in writing by Gareth Morgan.
//  - Gareth Morgan is NOT responsible for future maintenance, updates, security patching,
//    or operational upkeep if this application is deployed, copied, or modified without
//    his written consent.
//  - Gareth Morgan reserves the right to:
//        Withdraw or disable access to the application or related services
//        Remove hosted, cloud-based, or linked services under his control
//        Revoke access to Build My Checksrelated assets, code, APIs, or integrations
//
//   2025 Gareth Morgan  BuildMyChecks.co.uk
//  Unauthorized use, alteration, copying, or redistribution without written consent
//  is strictly prohibited.
//
//  ----------------------------------------------------------------------------------------------
//  Build My Checks  ASCII Logo Signature
//  (Symbolic representation of BuildMyChecks.co.uk identity)
//
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................:-==++-.........:-:.............................................
// ...................................-*******:.......=*****+-.........................................
// ...................................=*******+:.....+*******=.........................................
// .........................::........+**********************=.........................................
// .......................-+***+-.:-++***********************=:.......:................................
// .....................-+*************************************+-..=+**+-..............................
// .....................:+*************+=-.............-++***************+:............................
// ......................:+********+=:.....................:=*************=............................
// .......................=******+:...........................-+********+-.............................
// ......................-*****+:...............................-+*****+-..............................
// ................:::::+****+-...................................=*****+..............................
// ...............+-......:=+-........+=.*%=......##:.:::.....:::..-*****=.............................
// ..............=*-*@%%%%@*.........-#*:#@=......@%::@@@*...*@@#...-+++++**++=-.......................
// .............:**-*@*..=@%.=#+..*#=-%#:#@=.=#%#+@%::@%%%-.=@%@#-##:..##:+*****:......................
// ..............-+-*@@%%@%+.+@*..#@==%#:#@==@%-:+@%::@#-@#:%#+%#.+@#.*@+-******=......................
// .................*@*..:#@++@*..#@==%#:#@=+@#...@%::@#.+@%%-=%#..%@#%#:+******+......................
// .................*@%##%@#.-%@%%@@==%#:#@=:#@%#%%%::@#.:#@*.=%#...%@%:=****+-:.......................
// ..................::........::.........:....::.....:....:......:-#@--***+:..........................
// ................:++:+@@@@@*.:@#:.....................#%=......:#%#-.+***+:..........................
// .............-+**+:#@*:.:+%+:@#-=+-...:=+=-....-+=-..#%=.:=-..-++-..+***+:..........................
// .............+***=-@%.......:@@#+#@#.+@#-+%#:+@%++@%:#%+*@#::%#--*-:*****+-.........................
// .............-***=:@%.......:@%:.-%%:%@%%%%%+#@=.....#@@@%:..#%@@%-=**+++++*+.......................
// ..............****-+%@*=+%@*:@%:.-%%.*@*-=*=.*@%==%#:#@+=@%=:++-+@*-+--===:+=.......................
// .................::::=***=:..++..:++..-+**=...:+**+:.=+-.:++:-*#*=::-:+***=::-++:...................
// ....................-****+=............................*#......+*****************=..................
// .....................=*****=.......+##+.:+##=....*+.-#-*#.**:..:+************++*=...................
// .....................+******+-....*%..:.%*.:%+..:%*.=%=*%%*..:--***********+:..-+:..................
// ....................+*********=:%=+%*+%-*%+*%-=#-#%*%@=*#:%*:+****+++****+=...=*****-...............
// ...................=**********+--::.::....::...:..::.:.:-::-:=***+:..=+*+:..:+******-...............
// ....................-******++*******+=-:............-=++****+=+***+:...:...=******+-:...............
// ......................-++-....=+***************************+=+-=****+:...-+******-..................
// ................................=**********************++-:....=******=:+********=..................
// ................................=**********************=......:+*****************+:.................
// ................................+*******=......+*******=........-+=.:=+****+-.-+-...................
// ................................:-=+***-........+******=..............=***+.........................
// .................................................--::...............................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
//
// ==============================================================================================

import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import logo from '../../assets/image/logo_web.png';

export default function RefundPolicy() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Refund & Cancellation Policy</h1>
        <p className="text-sm text-gray-500 mb-8">Last updated: 20 November 2025</p>

        <div className="prose prose-lg max-w-none space-y-6">
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Our Commitment to Customer Satisfaction</h2>
            <p className="text-gray-700">
              At Build My Checks, we want you to be completely satisfied with our service. This policy explains your 
              rights to cancel your subscription and request refunds.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">1. 30-Day Money-Back Guarantee</h2>
            <p className="text-gray-700 mb-4">
              We offer a <strong>30-day money-back guarantee</strong> for all new customers.
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>If you cancel within 30 days of your <strong>first payment</strong>, we will issue a full refund</li>
              <li>The refund will be processed to the original payment method within 5-10 business days</li>
              <li>You will retain access to the Service until the refund is processed</li>
              <li>No questions asked - we simply want you to be happy with your choice</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">2. How to Cancel Your Subscription</h2>
            <p className="text-gray-700 mb-4">You can cancel your subscription at any time using either method:</p>
            
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Option 1: Self-Service Cancellation</h3>
            <ol className="list-decimal pl-6 text-gray-700 space-y-2 mb-4">
              <li>Log in to your Build My Checks account</li>
              <li>Go to <strong>Settings → Subscription</strong></li>
              <li>Click <strong>Cancel Subscription</strong></li>
              <li>Confirm your cancellation</li>
              <li>You will receive a confirmation email immediately</li>
            </ol>

            <h3 className="text-xl font-semibold text-gray-900 mb-3">Option 2: Email Support</h3>
            <p className="text-gray-700 mb-2">
              Send an email to <a href="mailto:support@buildmychecks.co.uk" className="text-primary hover:underline">support@buildmychecks.co.uk</a> with:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Subject line: "Cancellation Request"</li>
              <li>Your account email address</li>
              <li>Company name (if applicable)</li>
              <li>We will process your cancellation within 24 hours</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">3. When Your Cancellation Takes Effect</h2>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Cancellations take effect at the <strong>end of your current billing period</strong></li>
              <li>You will continue to have full access to the Service until the end of your paid period</li>
              <li>No further charges will be made after your current billing period ends</li>
              <li>You will receive a confirmation email with your final access date</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Refund Policy After 30 Days</h2>
            <p className="text-gray-700 mb-4">
              After the initial 30-day money-back guarantee period:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li><strong>No pro-rata refunds:</strong> We do not issue refunds for partial months of service</li>
              <li><strong>Cancel to stop future charges:</strong> You can cancel at any time to prevent future billing</li>
              <li><strong>Exceptional circumstances:</strong> We may consider refund requests in exceptional cases (e.g., prolonged service outages caused by us) on a case-by-case basis</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">5. What Happens to Your Data After Cancellation</h2>
            <p className="text-gray-700 mb-4">When you cancel your subscription:</p>
            
            <h3 className="text-xl font-semibold text-gray-900 mb-3">During the 30-Day Grace Period</h3>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
              <li>After your subscription ends, you have <strong>30 days</strong> to export your data</li>
              <li>You can log in and download all your checklists, inspection reports, and photos as PDF or CSV files</li>
              <li>Your account will be in "read-only" mode during this period</li>
            </ul>

            <h3 className="text-xl font-semibold text-gray-900 mb-3">After the 30-Day Grace Period</h3>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Your account and all associated data will be <strong>permanently deleted</strong></li>
              <li>This includes all checklists, forms, inspection submissions, photos, signatures, and reports</li>
              <li><strong>This action cannot be undone</strong> - please ensure you have exported any data you need before the grace period expires</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Re-activating a Canceled Subscription</h2>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>If you cancel but change your mind during your paid period, you can re-activate from your account settings</li>
              <li>If you re-subscribe within the 30-day grace period, your data will be restored</li>
              <li>After the 30-day grace period, your data is permanently deleted and cannot be recovered</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Subscription Changes & Downgrades</h2>
            <p className="text-gray-700 mb-4">
              If you want to reduce the number of users rather than cancel completely:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Log in and go to <strong>Settings → Team Members</strong></li>
              <li>Remove users you no longer need</li>
              <li>Your next bill will automatically reflect the reduced number of users</li>
              <li>Changes take effect immediately, but you are not charged until your next billing date</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Billing Disputes</h2>
            <p className="text-gray-700 mb-4">
              If you believe you have been incorrectly charged:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Contact us immediately at <a href="mailto:support@buildmychecks.co.uk" className="text-primary hover:underline">support@buildmychecks.co.uk</a></li>
              <li>Include your invoice number and details of the disputed charge</li>
              <li>We will investigate within 2 business days</li>
              <li>If an error is confirmed, we will issue a refund within 5-10 business days</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Payment Processing Partner</h2>
            <p className="text-gray-700 mb-4">
              All payments are processed securely by <strong>Stripe</strong>, a PCI-DSS Level 1 certified payment provider.
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>We never store your full credit card details on our servers</li>
              <li>Stripe handles all payment card information in compliance with banking regulations</li>
              <li>Refunds are issued through Stripe to the original payment method</li>
              <li>For payment-specific questions, you can also contact Stripe support</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Your Consumer Rights (UK)</h2>
            <p className="text-gray-700 mb-4">
              This refund policy does not affect your statutory rights under UK consumer law:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Consumer Rights Act 2015</li>
              <li>Consumer Contracts (Information, Cancellation and Additional Charges) Regulations 2013</li>
              <li>You have the right to cancel within 14 days of signing up (separate from our 30-day guarantee)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Contact Us About Refunds</h2>
            <p className="text-gray-700 mb-4">
              If you have any questions about cancellations or refunds:
            </p>
            <ul className="list-none text-gray-700 space-y-1">
              <li><strong>Email:</strong> support@buildmychecks.co.uk</li>
              <li><strong>Expected response time:</strong> Within 24 hours on business days</li>
            </ul>
          </section>

          <section className="bg-blue-50 p-6 rounded-lg border-l-4 border-primary">
            <h3 className="text-xl font-bold text-gray-900 mb-3">📧 Need Help?</h3>
            <p className="text-gray-700">
              Before canceling, please let us know if you're experiencing any issues with the Service. 
              Our support team is here to help and may be able to resolve your concerns. 
              Contact us at <a href="mailto:support@buildmychecks.co.uk" className="text-primary hover:underline font-semibold">support@buildmychecks.co.uk</a>
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8 mt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-sm text-gray-400">&copy; 2025 Build My Checks. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

// ----------------------------------------------------------------------------------------------
//  Build My Checks (c) 2025 Gareth Morgan - BuildMyChecks.co.uk
//  Solely designed, developed, and maintained by Gareth Morgan.
//  All intellectual property rights reserved.
//  No liability is accepted for unauthorised use, modification, deployment, or maintenance.
// ----------------------------------------------------------------------------------------------
